export const colors: string[] = [
  "#4cccb8", // AcadéNice turquoise
  "#fda100", // AcadéNice orange
  /* ------ ----- ----- COULEURS DE BASES ----- ----- ----- */
  "#475569", // slate-600
  "#57534e", // stone-600
  "#dc2626", // red-600
  "#ea580c", // orange-600
  "#d97706", // amber-600
  "#ca8a04", // yellow-600
  "#65a30d", // lime-600
  "#16a34a", // green-600
  "#059669", // emerald-600
  "#0d9488", // teal-600
  "#0891b2", // cyan-600
  "#0284c7", // sky-600
  "#2563eb", // blue-600
  "#4f46e5", // indigo-600
  "#7c3aed", // violet-600
  "#9333ea", // purple-600
  "#c026d3", // fuchsia-600
  "#db2777", // pink-600
  "#e11d48", // rose-600
];
